export default {
    // 中
    zhCN: {
        sales_order: '销售单',
        pack_no: '箱单号',
        pack_status: '箱单状态',
        history: '历史',
        order_confirm: '订单确认',
        order_submit: '订单提交',
        order_cancel: '订单取消',
        order_reviewed_today: '今日已审核订单',
        anji_logistics: '安吉物流',
        fund_review: '资金审核',
        pack: '箱单包装',
        bo_cancel: 'BO取消',
        sale_orders_query: '销售单查询',
        notice_history_query: '通知历史查询',
        is_read: '已读/未读',
        is_read_y: '已读',
        is_read_n: '未读',
        notice: '通知',
        notice_type: '通知类型',
        notice_time: '通知日期',
        notice_msg: '通知消息',
        operation_change_review: '改运审核',
        review_returned: '审核退回',
        bo_cancel_to_review: 'BO取消待审核',
    },
    // 英
    enUS: {
        sales_order: 'Sales order',
        pack_no: 'Pack no',
        pack_status: 'Pack status',
        history: 'History',
        order_confirm: 'Order confirm',
        order_submit: 'Order submit',
        order_cancel: 'Order cancel',
        order_reviewed_today: 'Order reviewed today',
        anji_logistics: 'Anji logistics',
        fund_review: 'Fund review',
        pack: 'Pack',
        bo_cancel: 'BO cancel',
        sale_orders_query: 'Sales orders query',
        notice_history_query: 'Notice history query',
        is_read: 'Read/Unread',
        is_read_y: 'Read',
        is_read_n: 'Unread',
        notice: 'Notice',
        notice_type: 'Notice type',
        notice_time: 'Notice time',
        notice_msg: 'Notice message',
        operation_change_review: 'Operation change review',
        review_returned: 'Review returned',
        bo_cancel_to_review: 'BO cancel to review',
    },
    // 德
    deDE: {
        sales_order: 'Verkaufsauftrag',
        pack_no: 'Packnummer',
        pack_status: 'Packstatus',
        history: 'Geschichte',
        order_confirm: 'Bestellung bestätigen',
        order_submit: 'Bestellung abschließen',
        order_cancel: 'Bestellung stornieren',
        order_reviewed_today: 'Heute überprüfte Bestellungen',
        anji_logistics: 'Anji Logistik',
        fund_review: 'Fondsprüfung',
        pack: 'Packen',
        bo_cancel: 'BO-Stornierung',
        sale_orders_query: 'Abfrage der Verkaufsaufträge',
        notice_history_query: 'Abfrage des Verlaufes der Benachrichtigungen',
        is_read: 'Gelesen/Ungelesen',
        is_read_y: 'Gelesen',
        is_read_n: 'Ungelesen',
        notice: 'Notiz',
        notice_type: 'Benachrichtigungstyp',
        notice_time: 'Benachrichtigungszeit',
        notice_msg: 'Benachrichtigungsnachricht',
        operation_change_review: 'Überprüfung der Betriebsänderung',
        review_returned: 'Überprüfung zurückgesandt',
        bo_cancel_to_review: 'BO-Stornierung zur Überprüfung',
    },
    // 法
    frFR: {
        sales_order: 'Commande de vente',
        pack_no: 'N° de colis',
        pack_status: 'Statut du colis',
        history: 'Historique',
        order_confirm: 'Confirmation de commande',
        order_submit: 'Soumettre la commande',
        order_cancel: 'Annuler la commande',
        order_reviewed_today: 'Commande examinée aujourd\'hui',
        anji_logistics: 'Logistique Anji',
        fund_review: 'Examen des fonds',
        pack: 'Colis',
        bo_cancel: 'Annulation de BO',
        sale_orders_query: 'Recherche de commandes de vente',
        notice_history_query: 'Recherche d\'historique des notifications',
        is_read: 'Lu/Non-lu',
        is_read_y: 'Lu',
        is_read_n: 'Non-lu',
        notice: 'Notification',
        notice_type: 'Type de notification',
        notice_time: 'Heure de notification',
        notice_msg: 'Message de notification',
        operation_change_review: 'Modification de l\'opération d\'examen',
        review_returned: 'Examen retourné',
        bo_cancel_to_review: 'Annulation de BO à réviser',
    },
    // 意大利
    itIT: {
        sales_order: 'Ordine di Vendita',
        pack_no: 'Numero del Pacco',
        pack_status: 'Stato del Pacco',
        history: 'Storia',
        order_confirm: 'Conferma dell’Ordine',
        order_submit: 'Invio dell’Ordine',
        order_cancel: 'Annulla Ordine',
        order_reviewed_today: 'Ordini Recensiti Oggi',
        anji_logistics: 'Logistica Anji',
        fund_review: 'Revisione Fondi',
        pack: 'Pacco Imballaggio',
        bo_cancel: 'Annullamento BO',
        sale_orders_query: 'Query Ordini di Vendita',
        notice_history_query: 'Query Storia delle Notifiche',
        is_read: 'Letto/Non Letto',
        is_read_y: 'Letto',
        is_read_n: 'Non Letto',
        notice: 'Notifica',
        notice_type: 'Tipo di Notifica',
        notice_time: 'Data della Notifica',
        notice_msg: 'Messaggio della Notifica',
        operation_change_review: 'Revisione Cambio Operazione',
        review_returned: 'Recensioni in Ritorno',
        bo_cancel_to_review: 'Annullamento BO in Attesa di Revisione',
    },
    // 荷兰
    nlNL: {
        sales_order: 'Verkooporder',
        pack_no: 'Pakketnummer',
        pack_status: 'Pakketstatus',
        history: 'Geschiedenis',
        order_confirm: 'Order bevestigen',
        order_submit: 'Order indienen',
        order_cancel: 'Order annuleren',
        order_reviewed_today: 'Order beoordeeld vandaag',
        anji_logistics: 'Anji Logistiek',
        fund_review: 'Fondsherziening',
        pack: 'Pakket',
        bo_cancel: 'BO Annuleren',
        sale_orders_query: 'Query Verkooporders',
        notice_history_query: 'Query Kondig Geschiedenis',
        is_read: 'Lezen / Ongelezen',
        is_read_y: 'Gelezen',
        is_read_n: 'Ongelezen',
        notice: 'Kennisgeving',
        notice_type: 'Type Kennisgeving',
        notice_time: 'Kennisgeving Tijd',
        notice_msg: 'Kennisgeving Bericht',
        operation_change_review: 'Wijzigingsbeoordeling',
        review_returned: 'Beoordeling Teruggestuurd',
        bo_cancel_to_review: 'BO Annuleren naar Beoordeling',
    },
    // 越南
    viVN: {
        sales_order: 'Đơn hàng bán',
        pack_no: 'Số thùng',
        pack_status: 'Trạng thái thùng',
        history: 'Lịch sử',
        order_confirm: 'Xác nhận đơn hàng',
        order_submit: 'Gửi đơn hàng',
        order_cancel: 'Hủy đơn hàng',
        order_reviewed_today: 'Đơn hàng đã được duyệt hôm nay',
        anji_logistics: 'Vận chuyển Anji',
        fund_review: 'Duyệt quỹ',
        pack: 'Đóng gói thùng',
        bo_cancel: 'Hủy BO',
        sale_orders_query: 'Tra cứu đơn hàng bán',
        notice_history_query: 'Tra cứu lịch sử thông báo',
        is_read: 'Đã đọc / Chưa đọc',
        is_read_y: 'Đã đọc',
        is_read_n: 'Chưa đọc',
        notice: 'Thông báo',
        notice_type: 'Loại thông báo',
        notice_time: 'Ngày thông báo',
        notice_msg: 'Nội dung thông báo',
        operation_change_review: 'Xét duyệt thay đổi hoạt động',
        review_returned: 'Hoạt động xét duyệt đã trả lại',
        bo_cancel_to_review: 'Hủy BO đợi xét duyệt',
    },
    // 西班牙
    esES: {
        sales_order: 'Pedido de venta',
        pack_no: 'Número de paquete',
        pack_status: 'Estado del paquete',
        history: 'Historial',
        order_confirm: 'Confirmar pedido',
        order_submit: 'Enviar pedido',
        order_cancel: 'Cancelar pedido',
        order_reviewed_today: 'Pedidos revisados hoy',
        anji_logistics: 'Logística de Anji',
        fund_review: 'Revisión de fondos',
        pack: 'Empaquetar',
        bo_cancel: 'Cancelar BO',
        sale_orders_query: 'Consulta de pedidos de venta',
        notice_history_query: 'Consulta de historial de notificaciones',
        is_read: 'Leído/No leído',
        is_read_y: 'Leído',
        is_read_n: 'No leído',
        notice: 'Notificación',
        notice_type: 'Tipo de notificación',
        notice_time: 'Fecha de notificación',
        notice_msg: 'Mensaje de notificación',
        operation_change_review: 'Revisión de cambio de operación',
        review_returned: 'Revisión devuelta',
        bo_cancel_to_review: 'Cancelación de BO pendiente de revisión',
    },
    // 葡萄牙
    ptBR: {
        sales_order: 'Ordem de venda',
        pack_no: 'Número do pacote',
        pack_status: 'Status do pacote',
        history: 'Histórico',
        order_confirm: 'Confirmação do pedido',
        order_submit: 'Enviar pedido',
        order_cancel: 'Cancelar pedido',
        order_reviewed_today: 'Pedidos revisados ​​hoje',
        anji_logistics: 'Logística Anji',
        fund_review: 'Revisão do fundo',
        pack: 'Embalagem de Pacote',
        bo_cancel: 'BO cancelado',
        sale_orders_query: 'Consulta de pedidos de venda',
        notice_history_query: 'Consulta de histórico de aviso',
        is_read: 'Lido/Não lido',
        is_read_y: 'Lido',
        is_read_n: 'Não lido',
        notice: 'Aviso',
        notice_type: 'Tipo de aviso',
        notice_time: 'Data do aviso',
        notice_msg: 'Mensagem do aviso',
        operation_change_review: 'Revisão da mudança de operação',
        review_returned: 'Revisão devolvida',
        bo_cancel_to_review: 'BO cancelado aguardando revisão',
    },
    // 波兰
    plPL: {
        sales_order: 'Zamówienie sprzedaży',
        pack_no: 'Numer paczki',
        pack_status: 'Status paczki',
        history: 'Historia',
        order_confirm: 'Potwierdzenie zamówienia',
        order_submit: 'Przesłanie zamówienia',
        order_cancel: 'Anulowanie zamówienia',
        order_reviewed_today: 'Dzisiejsze zatwierdzone zamówienia',
        anji_logistics: 'Logistyka Anji',
        fund_review: 'Przegląd funduszy',
        pack: 'Opakowanie paczek',
        bo_cancel: 'Anuluj BO',
        sale_orders_query: 'Zapytanie o zamówienia sprzedaży',
        notice_history_query: 'Zapytanie o historię powiadomień',
        is_read: 'Przeczytane/Nieprzeczytane',
        is_read_y: 'Przeczytane',
        is_read_n: 'Nieprzeczytane',
        notice: 'Powiadomienie',
        notice_type: 'Typ powiadomienia',
        notice_time: 'Data powiadomienia',
        notice_msg: 'Wiadomość powiadomienia',
        operation_change_review: 'Przegląd zmiany operacji',
        review_returned: 'Przegląd zwrócony',
        bo_cancel_to_review: 'Anulowanie BO do przeglądu',
    },
    // 土耳其语
    trTR: {
        sales_order: 'Satış Siparişi',
        pack_no: 'Kutu Numarası',
        pack_status: 'Kutu Durumu',
        history: 'Geçmiş',
        order_confirm: 'Sipariş Onayı',
        order_submit: 'Sipariş Gönderimi',
        order_cancel: 'Sipariş İptali',
        order_reviewed_today: 'Bugün İncelenen Siparişler',
        anji_logistics: 'Anji Lojistik',
        fund_review: 'Fon İnceleme',
        pack: 'Kutu Paketleme',
        bo_cancel: 'BO İptali',
        sale_orders_query: 'Satış Siparişleri Sorgusu',
        notice_history_query: 'Bildirim Geçmişi Sorgusu',
        is_read: 'Okundu/Okunmadı',
        is_read_y: 'Okundu',
        is_read_n: 'Okunmadı',
        notice: 'Bildirim',
        notice_type: 'Bildirim Türü',
        notice_time: 'Bildirim Tarihi',
        notice_msg: 'Bildirim Mesajı',
        operation_change_review: 'Operasyon Değişikliği İnceleme',
        review_returned: 'İnceleme İade Edildi',
        bo_cancel_to_review: 'BO İptali İnceleme Bekliyor',
    },
    // 捷克语
    csCZ: {
        sales_order: 'Prodejní objednávka',
        pack_no: 'Balení č',
        pack_status: 'Stav balíku',
        history: 'Historie',
        order_confirm: 'Potvrzení objednávky',
        order_submit: 'Odeslání objednávky',
        order_cancel: 'Zrušení objednávky',
        order_reviewed_today: 'Objednávka dnes zkontrolována',
        anji_logistics: 'Anji logistika',
        fund_review: 'Revize fondu',
        pack: 'Balíček',
        bo_cancel: 'Zrušení zpětné objednávky',
        sale_orders_query: 'Dotaz na prodejní objednávky',
        notice_history_query: 'Dotaz na historii oznámení',
        is_read: 'Přečteno/Nepřečteno',
        is_read_y: 'Číst',
        is_read_n: 'Nepřečtený',
        notice: 'Oznámení',
        notice_type: 'Typ oznámení',
        notice_time: 'Čas upozornění',
        notice_msg: 'Zpráva s upozorněním',
        operation_change_review: 'Přezkoumání změny operace',
        review_returned: 'Review returned',
        bo_cancel_to_review: 'Zrušená zpětné objednávky k přezkoumání',
    },
    // 匈牙利语
    huHU: {
        sales_order: 'Értékesítési rendelés',
        pack_no: 'Csomagsz.',
        pack_status: 'Csomagállapot',
        history: 'Előzmény',
        order_confirm: 'Rendelésmegerősítés',
        order_submit: 'Rendelésbeküldés',
        order_cancel: 'Rendeléstörlés',
        order_reviewed_today: 'Rendelés ma ellenőrizve',
        anji_logistics: 'Anji logisztika',
        fund_review: 'Tőkeellenőrzés',
        pack: 'Csomag',
        bo_cancel: 'FR törlése',
        sale_orders_query: 'Értékesítési rendelés lekérdezése',
        notice_history_query: 'Értesítési előzmények lekérdezése',
        is_read: 'Olvasott/Olvasatlan',
        is_read_y: 'Olvasott',
        is_read_n: 'Olvasatlan',
        notice: 'Értesítés',
        notice_type: 'Értesítéstípus',
        notice_time: 'Értesítési idő',
        notice_msg: 'Értesítési üzenet',
        operation_change_review: 'Műveletmódosítás ellenőrzése',
        review_returned: 'Visszaküldött ellenőrzése',
        bo_cancel_to_review: 'FR törlésének ellenőrzése',
    },
    // 俄罗斯
    ruRU: {
        sales_order: 'Продажа заказа',
        pack_no: 'Упаковать нет',
        pack_status: 'Статус упаковки',
        history: 'История',
        order_confirm: 'Подтверждение заказа',
        order_submit: 'Отправить заказ',
        order_cancel: 'Отмена заказа',
        order_reviewed_today: 'Заказ проверен сегодня',
        anji_logistics: 'Анжи логистика',
        fund_review: 'Обзор фонда',
        pack: 'Упаковать',
        bo_cancel: 'BO отменить',
        sale_orders_query: 'Запрос заказов на продажу',
        notice_history_query: 'Запрос истории уведомлений',
        is_read: 'Прочитано/не прочитано',
        is_read_y: 'Прочитано',
        is_read_n: 'Не прочитано',
        notice: 'Уведомление',
        notice_type: 'Тип уведомления',
        notice_time: 'Дата уведомления',
        notice_msg: 'Сообщение уведомления',
        operation_change_review: 'Изменение операции пересмотреть',
        review_returned: 'Проверка возвращена',
        bo_cancel_to_review: 'BO отменить для пересмотра',
    },
    // 沙特阿拉伯
    arSA: {
        sales_order: 'طلب مبيعات',
        pack_no: 'رقم قائمة التغليف',
        pack_status: 'حالة قائمة التغليف',
        history: 'السجل',
        order_confirm: 'تأكيد الطلب',
        order_submit: 'تقديم الطلب',
        order_cancel: 'إلغاء الطلب',
        order_reviewed_today: 'الطلبات التي تم مراجعتها اليوم',
        anji_logistics: 'أنجي للخدمات اللوجستية',
        fund_review: 'مراجعة التمويل',
        pack: 'تغليف القائمة',
        bo_cancel: 'إلغاء BO',
        sale_orders_query: 'استعلام طلبات المبيعات',
        notice_history_query: 'استعلام سجل الإشعارات',
        is_read: 'مقروء/غير مقروء',
        is_read_y: 'مقروء',
        is_read_n: 'غير مقروء',
        notice: 'إشعار',
        notice_type: 'نوع الإشعار',
        notice_time: 'تاريخ الإشعار',
        notice_msg: 'رسالة الإشعار',
        operation_change_review: 'مراجعة تغيير الشحن',
        review_returned: 'تم إرجاع المراجعة',
        bo_cancel_to_review: 'إلغاء BO بانتظار المراجعة',
    },
    // 保加利亚
    bgBG: {
        sales_order: 'Поръчка за продажба',
        pack_no: 'Номер на пакетна декларация',
        pack_status: 'Статус на пакетната декларация',
        history: 'История',
        order_confirm: 'Потвърждаване на поръчката',
        order_submit: 'Изпращане на поръчката',
        order_cancel: 'Отмяна на поръчката',
        order_reviewed_today: 'Поръчки, прегледани днес',
        anji_logistics: 'Анжи Лоджистикс',
        fund_review: 'Финансов преглед',
        pack: 'Опаковане по пакетна декларация',
        bo_cancel: 'Отмяна на BO',
        sale_orders_query: 'Запитване за поръчки за продажба',
        notice_history_query: 'Запитване за история на известията',
        is_read: 'Прочетено/Непрочетено',
        is_read_y: 'Прочетено',
        is_read_n: 'Непрочетено',
        notice: 'Известие',
        notice_type: 'Тип известие',
        notice_time: 'Дата на известие',
        notice_msg: 'Съобщение на известие',
        operation_change_review: 'Преглед на промяна в транспортирането',
        review_returned: 'Върнато за преглед',
        bo_cancel_to_review: 'Отмяна на BO – изчаква преглед',
    },
    // 丹麦语
    daDK: {
        sales_order: 'Salgsordre',
        pack_no: 'Pakkeliste nummer',
        pack_status: 'Pakkeliste status',
        history: 'Historik',
        order_confirm: 'Bekræft ordre',
        order_submit: 'Indsend ordre',
        order_cancel: 'Annuller ordre',
        order_reviewed_today: 'Ordre gennemgået i dag',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Finansiel godkendelse',
        pack: 'Pakkeliste pakning',
        bo_cancel: 'BO annulleret',
        sale_orders_query: 'Søg salgsordrer',
        notice_history_query: 'Søg i notifikationshistorik',
        is_read: 'Læst/ulæst',
        is_read_y: 'Læst',
        is_read_n: 'Ulæst',
        notice: 'Notifikation',
        notice_type: 'Notifikationstype',
        notice_time: 'Notifikationsdato',
        notice_msg: 'Notifikationsmeddelelse',
        operation_change_review: 'Gennemgang af ændret forsendelse',
        review_returned: 'Returneret til gennemgang',
        bo_cancel_to_review: 'BO annullering afventer gennemgang',
    },
    // 芬兰语
    fiFI: {
        sales_order: 'Myyntitilaus',
        pack_no: 'Pakkauksen numero',
        pack_status: 'Pakkauksen tila',
        history: 'Historia',
        order_confirm: 'Vahvista tilaus',
        order_submit: 'Lähetä tilaus',
        order_cancel: 'Peruuta tilaus',
        order_reviewed_today: 'Tänään tarkastetut tilaukset',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Rahoituksen tarkastus',
        pack: 'Pakkauslistaus',
        bo_cancel: 'BO-peruutus',
        sale_orders_query: 'Myyntitilausten haku',
        notice_history_query: 'Ilmoitushistorian haku',
        is_read: 'Luettu/lukematon',
        is_read_y: 'Luettu',
        is_read_n: 'Lukematon',
        notice: 'Ilmoitus',
        notice_type: 'Ilmoituksen tyyppi',
        notice_time: 'Ilmoituksen päivämäärä',
        notice_msg: 'Ilmoituksen viesti',
        operation_change_review: 'Muutoksen tarkastus',
        review_returned: 'Palautettu tarkastettavaksi',
        bo_cancel_to_review: 'BO-peruutus odottaa tarkastusta',
    },
    // 繁体中文台湾
    zhTW: {
        sales_order: '銷售單',
        pack_no: '箱單號',
        pack_status: '箱單狀態',
        history: '歷史',
        order_confirm: '訂單確認',
        order_submit: '訂單提交',
        order_cancel: '訂單取消',
        order_reviewed_today: '今日已審核訂單',
        anji_logistics: '安吉物流',
        fund_review: '資金審核',
        pack: '箱單包裝',
        bo_cancel: 'BO取消',
        sale_orders_query: '銷售單查詢',
        notice_history_query: '通知歷史查詢',
        is_read: '已讀/未讀',
        is_read_y: '已讀',
        is_read_n: '未讀',
        notice: '通知',
        notice_type: '通知類型',
        notice_time: '通知日期',
        notice_msg: '通知訊息',
        operation_change_review: '改運審核',
        review_returned: '審核退回',
        bo_cancel_to_review: 'BO取消待審核',
    },
    // 克罗地亚
    hrHR: {
        sales_order: 'Prodajni nalog',
        pack_no: 'Broj pakirnog lista',
        pack_status: 'Status pakirnog lista',
        history: 'Povijest',
        order_confirm: 'Potvrda narudžbe',
        order_submit: 'Podnošenje narudžbe',
        order_cancel: 'Otkazivanje narudžbe',
        order_reviewed_today: 'Narudžbe pregledane danas',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Revizija sredstava',
        pack: 'Pakiranje prema listi',
        bo_cancel: 'Otkaz BO-a',
        sale_orders_query: 'Upit za prodajne narudžbe',
        notice_history_query: 'Upit za povijest obavijesti',
        is_read: 'Pročitano/Nepročitano',
        is_read_y: 'Pročitano',
        is_read_n: 'Nepročitano',
        notice: 'Obavijest',
        notice_type: 'Vrsta obavijesti',
        notice_time: 'Datum obavijesti',
        notice_msg: 'Poruka obavijesti',
        operation_change_review: 'Pregled promjene prijevoza',
        review_returned: 'Vraćeno na pregled',
        bo_cancel_to_review: 'Otkaz BO-a čeka pregled',
    },
    // 拉脱维亚
    lvLV: {
        sales_order: 'Pārdošanas pasūtījums',
        pack_no: 'Iepakojuma numurs',
        pack_status: 'Iepakojuma statuss',
        history: 'Vēsture',
        order_confirm: 'Pasūtījuma apstiprināšana',
        order_submit: 'Pasūtījuma iesniegšana',
        order_cancel: 'Pasūtījuma atcelšana',
        order_reviewed_today: 'Šodien pārbaudītie pasūtījumi',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Finansējuma pārbaude',
        pack: 'Iepakojuma sagatavošana',
        bo_cancel: 'BO atcelšana',
        sale_orders_query: 'Pārdošanas pasūtījumu vaicājums',
        notice_history_query: 'Paziņojumu vēstures vaicājums',
        is_read: 'Lasīts/Neizlasīts',
        is_read_y: 'Lasīts',
        is_read_n: 'Neizlasīts',
        notice: 'Paziņojums',
        notice_type: 'Paziņojuma veids',
        notice_time: 'Paziņojuma datums',
        notice_msg: 'Paziņojuma ziņojums',
        operation_change_review: 'Pārvadājuma maiņas pārbaude',
        review_returned: 'Atgriezts pārbaudei',
        bo_cancel_to_review: 'BO atcelšana gaida pārbaudi',
    },
    // 立陶宛
    ltLT: {
        sales_order: 'Pardavimo užsakymas',
        pack_no: 'Pakuotės numeris',
        pack_status: 'Pakuotės būsena',
        history: 'Istorija',
        order_confirm: 'Patvirtinti užsakymą',
        order_submit: 'Pateikti užsakymą',
        order_cancel: 'Atšaukti užsakymą',
        order_reviewed_today: 'Šiandien peržiūrėti užsakymai',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Lėšų patvirtinimas',
        pack: 'Pakuotės ruošimas',
        bo_cancel: 'BO atšaukimas',
        sale_orders_query: 'Pardavimo užsakymų užklausa',
        notice_history_query: 'Pranešimų istorijos užklausa',
        is_read: 'Perskaityta/Neperskaityta',
        is_read_y: 'Perskaityta',
        is_read_n: 'Neperskaityta',
        notice: 'Pranešimas',
        notice_type: 'Pranešimo tipas',
        notice_time: 'Pranešimo data',
        notice_msg: 'Pranešimo žinutė',
        operation_change_review: 'Keisto siuntimo peržiūra',
        review_returned: 'Grąžinta peržiūrai',
        bo_cancel_to_review: 'BO atšaukimas laukia peržiūros',
    },
    // 罗马尼亚
    roRO: {
        sales_order: 'Comandă de vânzare',
        pack_no: 'Număr listă de ambalare',
        pack_status: 'Stare listă de ambalare',
        history: 'Istoric',
        order_confirm: 'Confirmare comandă',
        order_submit: 'Trimite comanda',
        order_cancel: 'Anulare comandă',
        order_reviewed_today: 'Comenzi revizuite astăzi',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Revizuire financiară',
        pack: 'Ambalare conform listei',
        bo_cancel: 'Anulare BO',
        sale_orders_query: 'Interogare comenzi de vânzare',
        notice_history_query: 'Interogare istoric notificări',
        is_read: 'Citit/Necitit',
        is_read_y: 'Citit',
        is_read_n: 'Necitit',
        notice: 'Notificare',
        notice_type: 'Tip notificare',
        notice_time: 'Data notificării',
        notice_msg: 'Mesaj notificare',
        operation_change_review: 'Revizuire modificare transport',
        review_returned: 'Returnat pentru revizuire',
        bo_cancel_to_review: 'Anulare BO în așteptarea revizuirii',
    },
    // 挪威博克马尔
    nbNO: {
        sales_order: 'Salgsordre',
        pack_no: 'Pakkelistenummer',
        pack_status: 'Pakkelistestatus',
        history: 'Historikk',
        order_confirm: 'Bekreft ordre',
        order_submit: 'Send inn ordre',
        order_cancel: 'Kanseller ordre',
        order_reviewed_today: 'Ordre gjennomgått i dag',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Økonomisk godkjenning',
        pack: 'Pakkelistepakking',
        bo_cancel: 'BO-avbestilling',
        sale_orders_query: 'Søk salgsordrer',
        notice_history_query: 'Søk i varsels historikk',
        is_read: 'Lest/ulest',
        is_read_y: 'Lest',
        is_read_n: 'Ulest',
        notice: 'Varsel',
        notice_type: 'Varseltype',
        notice_time: 'Varseldato',
        notice_msg: 'Varselmelding',
        operation_change_review: 'Gjennomgang av endret forsendelse',
        review_returned: 'Returnert til gjennomgang',
        bo_cancel_to_review: 'BO-avbestilling venter på gjennomgang',
    },
    // 葡萄牙语巴西
    ptBX: {
        sales_order: 'Pedido de venda',
        pack_no: 'Número da lista de embalagem',
        pack_status: 'Status da lista de embalagem',
        history: 'Histórico',
        order_confirm: 'Confirmar pedido',
        order_submit: 'Enviar pedido',
        order_cancel: 'Cancelar pedido',
        order_reviewed_today: 'Pedidos revisados hoje',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Revisão financeira',
        pack: 'Embalagem por lista',
        bo_cancel: 'Cancelamento BO',
        sale_orders_query: 'Consulta de pedidos de venda',
        notice_history_query: 'Consulta de histórico de notificações',
        is_read: 'Lido/Não lido',
        is_read_y: 'Lido',
        is_read_n: 'Não lido',
        notice: 'Notificação',
        notice_type: 'Tipo de notificação',
        notice_time: 'Data da notificação',
        notice_msg: 'Mensagem da notificação',
        operation_change_review: 'Revisão de alteração de transporte',
        review_returned: 'Devolvido para revisão',
        bo_cancel_to_review: 'Cancelamento BO aguardando revisão',
    },
    // 瑞典语
    svSE: {
        sales_order: 'Försäljningsorder',
        pack_no: 'Paketeringslistans nummer',
        pack_status: 'Status för paketeringslista',
        history: 'Historik',
        order_confirm: 'Bekräfta order',
        order_submit: 'Skicka in order',
        order_cancel: 'Avbryt order',
        order_reviewed_today: 'Order granskade idag',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Finansiell granskning',
        pack: 'Paketering enligt lista',
        bo_cancel: 'BO-avbokning',
        sale_orders_query: 'Sök försäljningsorder',
        notice_history_query: 'Sök i aviseringars historik',
        is_read: 'Läst/oläst',
        is_read_y: 'Läst',
        is_read_n: 'Oläst',
        notice: 'Avisering',
        notice_type: 'Typ av avisering',
        notice_time: 'Aviseringsdatum',
        notice_msg: 'Aviseringsmeddelande',
        operation_change_review: 'Granskning av ändrad frakt',
        review_returned: 'Återlämnad för granskning',
        bo_cancel_to_review: 'BO-avbokning väntar på granskning',
    },
    // 斯洛伐克
    skSK: {
        sales_order: 'Predajná objednávka',
        pack_no: 'Číslo balíkového listu',
        pack_status: 'Stav balíkového listu',
        history: 'História',
        order_confirm: 'Potvrdenie objednávky',
        order_submit: 'Odoslanie objednávky',
        order_cancel: 'Zrušenie objednávky',
        order_reviewed_today: 'Dnes skontrolované objednávky',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Finančné schválenie',
        pack: 'Balenie podľa zoznamu',
        bo_cancel: 'Zrušenie BO',
        sale_orders_query: 'Dopyt predajných objednávok',
        notice_history_query: 'Dopyt histórie oznámení',
        is_read: 'Prečítané/Neprečítané',
        is_read_y: 'Prečítané',
        is_read_n: 'Neprečítané',
        notice: 'Oznámenie',
        notice_type: 'Typ oznámenia',
        notice_time: 'Dátum oznámenia',
        notice_msg: 'Správa oznámenia',
        operation_change_review: 'Schvaľovanie zmeny dopravy',
        review_returned: 'Vrátené na schválenie',
        bo_cancel_to_review: 'Zrušenie BO čaká na schválenie',
    },
    // 斯洛文尼亚
    slSI: {
        sales_order: 'Prodajni naročilni list',
        pack_no: 'Številka pakirnega seznama',
        pack_status: 'Status pakirnega seznama',
        history: 'Zgodovina',
        order_confirm: 'Potrditev naročila',
        order_submit: 'Oddaja naročila',
        order_cancel: 'Preklic naročila',
        order_reviewed_today: 'Danes pregledana naročila',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Pregled sredstev',
        pack: 'Pakiranje po seznamu',
        bo_cancel: 'Preklic BO',
        sale_orders_query: 'Poizvedba prodajnih naročil',
        notice_history_query: 'Poizvedba zgodovine obvestil',
        is_read: 'Prebrano/Neprebrano',
        is_read_y: 'Prebrano',
        is_read_n: 'Neprebrano',
        notice: 'Obvestilo',
        notice_type: 'Vrsta obvestila',
        notice_time: 'Datum obvestila',
        notice_msg: 'Sporočilo obvestila',
        operation_change_review: 'Pregled spremembe prevoza',
        review_returned: 'Vrnjeno v pregled',
        bo_cancel_to_review: 'Preklic BO čaka na pregled',
    },
    // 泰语
    thTH: {
        sales_order: 'ใบสั่งขาย',
        pack_no: 'เลขที่รายการบรรจุ',
        pack_status: 'สถานะรายการบรรจุ',
        history: 'ประวัติ',
        order_confirm: 'ยืนยันคำสั่งซื้อ',
        order_submit: 'ส่งคำสั่งซื้อ',
        order_cancel: 'ยกเลิกคำสั่งซื้อ',
        order_reviewed_today: 'คำสั่งซื้อที่ตรวจสอบแล้ววันนี้',
        anji_logistics: 'แอนจี้ โลจิสติกส์',
        fund_review: 'ตรวจสอบการเงิน',
        pack: 'บรรจุตามรายการ',
        bo_cancel: 'ยกเลิก BO',
        sale_orders_query: 'ค้นหาใบสั่งขาย',
        notice_history_query: 'ค้นหาประวัติการแจ้งเตือน',
        is_read: 'อ่านแล้ว/ยังไม่อ่าน',
        is_read_y: 'อ่านแล้ว',
        is_read_n: 'ยังไม่อ่าน',
        notice: 'การแจ้งเตือน',
        notice_type: 'ประเภทการแจ้งเตือน',
        notice_time: 'วันที่แจ้งเตือน',
        notice_msg: 'ข้อความแจ้งเตือน',
        operation_change_review: 'ตรวจสอบการเปลี่ยนแปลงการขนส่ง',
        review_returned: 'ส่งกลับเพื่อตรวจสอบ',
        bo_cancel_to_review: 'ยกเลิก BO รอตรวจสอบ',
    },
    // 乌克兰语
    ukUA: {
        sales_order: 'Замовлення на продаж',
        pack_no: 'Номер упаковочного листа',
        pack_status: 'Статус упаковочного листа',
        history: 'Історія',
        order_confirm: 'Підтвердження замовлення',
        order_submit: 'Відправити замовлення',
        order_cancel: 'Скасувати замовлення',
        order_reviewed_today: 'Замовлення, перевірені сьогодні',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Фінансова перевірка',
        pack: 'Упаковка за списком',
        bo_cancel: 'Скасування BO',
        sale_orders_query: 'Запит замовлень на продаж',
        notice_history_query: 'Запит історії сповіщень',
        is_read: 'Прочитано/Не прочитано',
        is_read_y: 'Прочитано',
        is_read_n: 'Не прочитано',
        notice: 'Сповіщення',
        notice_type: 'Тип сповіщення',
        notice_time: 'Дата сповіщення',
        notice_msg: 'Повідомлення сповіщення',
        operation_change_review: 'Перевірка зміни доставки',
        review_returned: 'Повернуто на перевірку',
        bo_cancel_to_review: 'Скасування BO очікує перевірки',
    },
    // 希腊语
    elGR: {
        sales_order: 'Παραγγελία Πώλησης',
        pack_no: 'Αριθμός Λίστας Συσκευασίας',
        pack_status: 'Κατάσταση Λίστας Συσκευασίας',
        history: 'Ιστορικό',
        order_confirm: 'Επιβεβαίωση Παραγγελίας',
        order_submit: 'Υποβολή Παραγγελίας',
        order_cancel: 'Ακύρωση Παραγγελίας',
        order_reviewed_today: 'Παραγγελίες που ελέγχθηκαν σήμερα',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Έλεγχος Χρηματοδότησης',
        pack: 'Συσκευασία με Λίστα',
        bo_cancel: 'Ακύρωση BO',
        sale_orders_query: 'Αναζήτηση Παραγγελιών Πώλησης',
        notice_history_query: 'Αναζήτηση Ιστορικού Ειδοποιήσεων',
        is_read: 'Διαβάστηκε/Δεν Διαβάστηκε',
        is_read_y: 'Διαβάστηκε',
        is_read_n: 'Δεν Διαβάστηκε',
        notice: 'Ειδοποίηση',
        notice_type: 'Τύπος Ειδοποίησης',
        notice_time: 'Ημερομηνία Ειδοποίησης',
        notice_msg: 'Μήνυμα Ειδοποίησης',
        operation_change_review: 'Έλεγχος Αλλαγής Μεταφοράς',
        review_returned: 'Επιστράφηκε για Έλεγχο',
        bo_cancel_to_review: 'Η ακύρωση BO αναμένει έλεγχο',
    },
    // 爱沙尼亚
    etEE: {
        sales_order: 'Müügitellimus',
        pack_no: 'Pakendi numbri loend',
        pack_status: 'Pakendiloendi staatus',
        history: 'Ajalugu',
        order_confirm: 'Tellimuse kinnitamine',
        order_submit: 'Tellimuse esitamine',
        order_cancel: 'Tellimuse tühistamine',
        order_reviewed_today: 'Täna üle vaadatud tellimused',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Rahastuse ülevaade',
        pack: 'Pakendiloendi põhjal pakkimine',
        bo_cancel: 'BO tühistamine',
        sale_orders_query: 'Müügitellimuste päring',
        notice_history_query: 'Teavituste ajaloo päring',
        is_read: 'Loetud/Lugemata',
        is_read_y: 'Loetud',
        is_read_n: 'Lugemata',
        notice: 'Teavitus',
        notice_type: 'Teavituse tüüp',
        notice_time: 'Teavituse kuupäev',
        notice_msg: 'Teavituse sõnum',
        operation_change_review: 'Transpordi muudatuse ülevaade',
        review_returned: 'Tagasi ülevaatamiseks',
        bo_cancel_to_review: 'BO tühistamine ootab ülevaatamist',
    },
    // 哈萨克
    kkKZ: {
        sales_order: 'Сату тапсырысы',
        pack_no: 'Жинақталған тізім нөмірі',
        pack_status: 'Жинақталған тізім күйі',
        history: 'Тарих',
        order_confirm: 'Тапсырысты растау',
        order_submit: 'Тапсырысты жіберу',
        order_cancel: 'Тапсырысты болдырмау',
        order_reviewed_today: 'Бүгін қарап шығылған тапсырыстар',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Қаржылық тексеру',
        pack: 'Тізім бойынша жинақтау',
        bo_cancel: 'BO болдырмау',
        sale_orders_query: 'Сату тапсырыстарын сұрау',
        notice_history_query: 'Хабарландыру тарихын сұрау',
        is_read: 'Оқылды/Оқылмады',
        is_read_y: 'Оқылды',
        is_read_n: 'Оқылмады',
        notice: 'Хабарландыру',
        notice_type: 'Хабарландыру түрі',
        notice_time: 'Хабарландыру күні',
        notice_msg: 'Хабарландыру хабары',
        operation_change_review: 'Жөнелту өзгерісін тексеру',
        review_returned: 'Қайта тексеруге қайтарылды',
        bo_cancel_to_review: 'BO болдырмау тексеруді күтуде',
    },
    // 希伯来语
    heIL: {
        sales_order: 'הזמנת מכירה',
        pack_no: 'מספר רשימת אריזה',
        pack_status: 'סטטוס רשימת אריזה',
        history: 'היסטוריה',
        order_confirm: 'אישור הזמנה',
        order_submit: 'שליחת הזמנה',
        order_cancel: 'ביטול הזמנה',
        order_reviewed_today: 'הזמנות שנבדקו היום',
        anji_logistics: 'ANJI לוגיסטיקה',
        fund_review: 'בחינת מימון',
        pack: 'אריזה לפי רשימה',
        bo_cancel: 'ביטול BO',
        sale_orders_query: 'שאילתת הזמנות מכירה',
        notice_history_query: 'שאילתת היסטוריית התראות',
        is_read: 'נקרא/לא נקרא',
        is_read_y: 'נקרא',
        is_read_n: 'לא נקרא',
        notice: 'התראה',
        notice_type: 'סוג התראה',
        notice_time: 'תאריך ההתראה',
        notice_msg: 'הודעת ההתראה',
        operation_change_review: 'בחינת שינוי משלוח',
        review_returned: 'הוחזר לבדיקה',
        bo_cancel_to_review: 'ביטול BO ממתין לאישור',
    },
};
